module.exports = {
	"name": "Default",
	"supported": [],
	"axes": {
		"left stick x": {
			"index": 0
		},
		"left stick y": {
			"index": 1
		},
		"left trigger": {
			"index": 2
		},
		"right stick x": {
			"index": 3
		},
		"right stick y": {
			"index": 4
		},
		"right trigger": {
			"index": 5
		},
		"dpad x": {
			"index": 6
		},
		"dpad y": {
			"index": 7
		}
	},
	"buttons": {
		"a": {
			"index": 0
		},
		"b": {
			"index": 1
		},
		"x": {
			"index": 2
		},
		"y": {
			"index": 3
		},
		"left shoulder": {
			"index": 4
		},
		"right shoulder": {
			"index": 5
		},
		"back": {
			"index": 6
		},
		"start": {
			"index": 7
		},
		"home": {
			"index": 8
		},
		"left stick": {
			"index": 9
		},
		"right stick": {
			"index": 10
		},
		"dpad left": {
			"axis": 6,
			"direction": -1
		},
		"dpad right": {
			"axis": 6,
			"direction": 1
		},
		"dpad up": {
			"axis": 7,
			"direction": -1
		},
		"dpad down": {
			"axis": 7,
			"direction": 1
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/html5-gamepad/mappings/default.json
// module id = 200
// module chunks = 0